<template>
  <div class="station">
    <div class="station__information">
      <div
        class="station__information__alert"
        :class="'station__information__alert--' + Data.status"
        title="Marked faulty"
      >
        <font-awesome-icon :icon="['fas', 'bell']" />
      </div>
      <svg
        class="radial-range"
        title="Visual time remaining for current program"
        viewBox="0 0 120 120"
      >
        <circle
          class="radial-range__background"
          cx="50%"
          cy="50%"
          r="56"
          fill="none"
          stroke="#fff"
          stroke-width="14"
        />
        <circle
          class="radial-range__ring"
          cx="50%"
          cy="50%"
          r="54"
          fill="none"
          stroke="#3565b0"
          stroke-width="15"
          :style="{strokeDashoffset: Countdown}"
        />
      </svg>

      <div
        class="station__information__name"
        title="Stations ID/name"
      >
        <font-awesome-icon :icon="['custom', 'station']" />
        {{ Data.name }}
      </div>
      <div
        class="station__information__left"
        :title="$t('messages.sharedTexts.precipitationRate') "
      >
        <p>{{ getDenominator('centimetre', 'inch', 0) + '/' + $tc('messages.sharedTexts.time.h', 1) }}</p>
        <span
          v-if="Data.Id !== undefined"
        >
          {{ Data.precip ? convertUnits(Data.precip / 100, 'in', 'cm') : 0 }}
        </span>
      </div>
      <div
        class="station__information__right"
        :title="$t('messages.sharedTexts.stations.flowTitle', {waterUnit: getDenominator('litre', 'gallon', 2)})"
      >
        <p>{{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}</p>
        <span>{{ Data.expectedFlow ? convertUnits(Data.expectedFlow, 'gal/min', 'l/min') : 0 }}</span>
      </div>
    </div>

    <div class="station__body-wrapper">
      <div class="station__body">
        <h3>{{ Data.description }}</h3>
        <p v-if="Type === 'station'">
          <slot v-if="ComputedStations === 'Manually Started'">
            {{ $tc('messages.sharedTexts.stations.station', 1) }}
            {{ $t('messages.sharedTexts.status.running') }}
          </slot>
          <slot v-else-if="ComputedStations === 'Auto Started'">
            {{ $tc('messages.sharedTexts.stations.station', 1) }}
            {{ $t('messages.sharedTexts.status.running') }}
          </slot>
          <slot v-else>
            {{ $t('messages.sharedTexts.status.noRunning', {item: $tc('messages.sharedTexts.stations.station', 1)}) }}
          </slot>
        </p>
        <p v-else>
          {{ Data.description }}
        </p>
        <p v-if="Data.stStat">
          <slot v-if="ComputedStations !== null">
            <font-awesome-icon
              v-if="Data.stStat === 'Passive'"
              :icon="['fas', 'clock']"
            />
            {{ computedGetCamelStatus }}
          </slot>
        </p>
      </div>
      <div
        v-if="Type === 'select'"
        class="station__select"
      >
        <div
          class="g-fancy-checkbox"
          :class="[{'g-fancy-checkbox--checked':Data.selected}]"
          @click="ClickStationEdit"
        >
          <font-awesome-icon :icon="['fas', 'check']" />
        </div>
      </div>
      <div
        v-if="Type === 'program-station'"
        class="station__controls"
      >
        <button
          v-if="controllerModeCheck"
          type="button"
          class="station__controls__run-control g-btn g-btn--round disabled"
        >
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
        <button
          v-else-if="(typeof Number(Data.Id) == 'number') && Data.Id != undefined && Data.Id != 0"
          type="button"
          class="station__controls__run-control g-btn g-btn--round"
          @click="StopStEntry(ModalData.selSt)"
        >
          <font-awesome-icon
            class="station__controls__run-control__stop"
            :icon="['fas', 'stop']"
          />
        </button>
        <button
          v-else-if="Data.Id == '' || Data.Id == undefined"
          type="button"
          class="station__controls__run-control g-btn g-btn--round disabled"
        >
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
      </div>
      <div
        v-if="Type === 'station'"
        class="station__controls"
        title="Station Controls (Start/Stop/Set Runtime)"
      >
        <div
          v-if="store.getData('user.access.stationEdit')"
          class="station__controls__edit"
        >
          <button
            class="station__controls__edit__button g-btn"
            @click.stop="editClicked()"
          >
            Edit
          </button>
        </div>
        <button
          v-if="controllerModeCheck"
          type="button"
          class="station__controls__run-control g-btn g-btn--round disabled"
        >
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
        <button
          v-else
          type="button"
          class="station__controls__run-control g-btn g-btn--round"
          @click="StartAndStop($event, Data, Data.StId)"
        >
          <font-awesome-icon
            v-if="Data.stStat == 'Passive'"
            class="station__controls__run-control__play"
            :icon="['fas', 'play']"
          />
          <font-awesome-icon
            v-else
            :icon="['fas', 'stop']"
          />
        </button>
      </div>
      <div
        v-if="Type === 'survey' && !Data.isRunning && Object.keys(Data).length && surveyLastRunningEntry !== null"
        class="station__controls"
      >
        <button
          v-if="controllerModeCheck"
          type="button"
          class="station__controls__run-control g-btn g-btn--round disabled"
        >
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
        <button
          v-else
          type="button"
          :disabled="Timeout"
          class="station__controls__run-control g-btn g-btn--round"
          @click="StartAndStop($event, Data, Data.StId)"
        >
          <font-awesome-icon
            class="station__controls__run-control__play"
            :icon="['fas', 'play']"
          />
        </button>
      </div>
      <div
        v-if="Type === 'survey' && Data.isRunning"
        class="station__controls"
      >
        <button
          v-if="controllerModeCheck"
          type="button"
          class="station__controls__run-control g-btn g-btn--round disabled"
        >
          <font-awesome-icon :icon="['fas', 'times']" />
        </button>
        <button
          v-else
          type="button"
          :disabled="Timeout"
          class="station__controls__run-control g-btn g-btn--round"
          @click="StartAndStop($event, Data, Data.StId)"
        >
          <font-awesome-icon
            class="station__controls__run-control__pause"
            :icon="['fas', 'stop']"
          />
        </button>
      </div>
      <div
        v-if="Type === 'station'"
        ref="StationOptions"
        class="station__options"
        title="Info about Running Stations and related Programs"
        :class="{'open': OptionsToggleStatus}"
      >
        <div class="station__options-wrapper">
          <slot v-if="Data.runningEntries.length">
            <div
              v-for="runningEntry in Data.runningEntries"
              :key="runningEntry.handleID"
              class="station__options__row"
            >
              <div class="station__options__row__body">
                <p>{{ $t('messages.sharedTexts.time.endTime') }}: {{ formattedEndTime(runningEntry.stopTime) }}</p>
                <p>{{ $t('messages.sharedTexts.time.timeLeft') }}: {{ getTime(runningEntry) }}</p>
                <slot v-if="runningEntry.programID">
                  <p>
                    <font-awesome-icon
                      v-if="runningEntry.runningMode === 'Passive'"
                      :icon="['fas', 'clock']"
                    />
                    {{ runningEntry.runningMode }}
                  </p>
                  <p v-if="runningEntry.programID">
                    {{ $t('messages.sharedTexts.status.runBy', {item: $tc('messages.sharedTexts.programs.program', 1)}) }}: {{ runningEntry.programID }}
                  </p>
                </slot>
                <p v-else>
                  {{ $t('messages.sharedTexts.manuallyStarted') }}
                </p>
              </div>
              <div class="station__controls">
                <button
                  v-if="runningEntry.runningMode === 'Passive' || Type === 'survey'"
                  type="button"
                  class="station__controls__run-control g-btn g-btn--round"
                >
                  <font-awesome-icon
                    class="station__controls__run-control__play"
                    :icon="['fas', 'play']"
                  />
                </button>
                <button
                  v-else
                  type="button"
                  class="station__controls__run-control g-btn g-btn--round"
                  @click="StopStEntry(runningEntry)"
                >
                  <font-awesome-icon :icon="['fas', 'stop']" />
                </button>
              </div>
            </div>
          </slot>
          <div
            v-if="Data.runningEntries.length < 1"
            class="station__options__station-status-inactive"
          >
            {{ $t('messages.sharedTexts.status.noRunning', {item: $tc('messages.sharedTexts.stations.station', 0)}) }}
          </div>
          <div
            v-if="Data.state !== 'edit' || Data.state !== 'survey'"
            class="station__options__toggle-button"
            @click="OptionsToggleClick()"
          >
            <div class="station__options__toggle-button-wrapper">
              <font-awesome-icon :icon="['fas', 'angle-down']" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SocketHandler, UnitSystem} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import moment from 'moment'
import {secondsToObj} from '@/assets/javascript/Time-lib'
import $ from 'jquery'
import _ from 'lodash'

export default {
  name: 'StationComponent',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, UnitSystem],
  props: {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    Type: {
      type: String,
      default: ''
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SelectedStation: {
      type: Object,
      default: function() {
        return{}
      }
    },
    controllerModeCheck: {
      type: Boolean,
      default: false
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    Data: {
      type: Object,
      default: function() {
        return{
          Id: 0,
          StId: 0,
          name: '',
          description: '',
          isRunning: false,
          expectedFlow: '',
          runningEntries: [],
          stStat: '',
          stTopBtnName: '',
          status: '0',
          selected: false,
          emptyStationState: false,
        }
      }
    }
  },
  data() {
    return{
      surveyLastRunningEntry: null,
      Granularity: 100,
      TimeInPercentage: 0,
      OptionsToggleStatus: false,
      StInfo: {},
      InitState: '',
      StStat: {},
      Timeout: false,
      DefaultStation: {'duration': '', 'expectedFlow': '', 'name': ''},
      emptyStationState: false,
    }
  },
  computed: {
    computedGetCamelStatus() {
      const translation = this.$t(`messages.sharedTexts.status.${_.camelCase(this.ComputedStations)}`)
      const rtnString = typeof this.ComputedStations === 'string' ?  translation : ''
      return rtnString
    },
    ComputeSelected() {
      return this.Data.selected
    },
    ComputedStations() {
      let countAuto = 0
      let countMan = 0
      let StationStartState = ''
      let Data = this.Data.runningEntries

      if(this.Data.runningEntries !== undefined) {
        Data.forEach((element, index) => {
          if(element.runningMode === 'Manually Started') {
            countMan += 1
          } else if(element.runningMode === 'Auto Started') {
            countAuto += 1
          }
        })
      }
      if (countMan > 0) {
        StationStartState = 'Manually Started'
      } else if (countAuto > 0) {
        StationStartState = 'Auto Started'
      } else{
        StationStartState = null
      }
      return StationStartState
    },
    Update() {
      // No idea why it only works in computed, but it is used to trigger layout
      return this.Data.stStat
    },
    Countdown() {
      if(this.Data.stStat !== undefined && this.Data.stStat !== 'Passive') {
        return 0
      } else {
        return (339.292 - ((339.292 / this.Granularity)) * this.TimeInPercentage)
      }
    },
    computedrunningEntries() {
      return this.Data.runningEntries
    }
  },
  watch: {
    Update() {
      setTimeout(() => {
        this.SetLayout()
      }, 0)
    },
    OptionsToggleStatus() {
      this.SetLayout()
    },
    Data: {
      handler(newValue) {
        this.StStat = newValue.stStat // Should be a computed
      }
    },
    computedrunningEntries(runningEntries) {
      
      if(this.Type === 'survey' && runningEntries.length) {
        this.surveyLastRunningEntry = runningEntries[0].handleID
      }
      
      if(this.Data.stStat === 'Passive') {
        this.lastStopTime = 0
      }

      runningEntries.forEach(entry => {
        if (!entry.stopTime) {  // && (entry.remainTime < this.lastRemainTime)
          if(this.lastStopTime && this.lastStopTime > 0) {
            entry.stopTime = this.lastStopTime
          } else {
            entry.stopTime = parseInt(this.store.getData('controller.clientModifiedTime')) + parseInt(entry.remainTime) * 1000
            this.lastStopTime = entry.stopTime
          }
        }
        this.lastRemainTime = entry.remainTime  // for use in higher accuracy of checking stopTime and RemainTime (see && above)- not used at the moment - jimm 02mar2021 
      })
    }
  },
  mounted() {
    this.$emit('stationLoaded', this.Data.StId)
  },
  methods: {
    formattedEndTime(time) {
      const format = this.store.getData('settings.time.use12HourClock') ? 'M/D/YY hh:mm:ss a' : 'D/M/YY HH:mm:ss'
      return moment(parseInt(time, 10)).utc().format(format)
    },
    getTime(entry) {
      const time = entry.stopTime - this.store.getData('controller.clientModifiedTime')

      let timeObj = secondsToObj(time / 1000)
      
      const hours = (timeObj.hh > 0) ? timeObj.hh + this.$tc('messages.sharedTexts.time.h', 1) : ''
      const minutes = (timeObj.mm > 0) ? timeObj.mm + this.$tc('messages.sharedTexts.time.m', 1) : ''
      const seconds = (timeObj.ss > 0) ? timeObj.ss + this.$tc('messages.sharedTexts.time.s', 1) : ''

      return time <= 0 ? ` ...stopping` : `~ ${hours} ${minutes} ${seconds}`
    },
    editClicked() {
      this.$emit('openStationEdit', this.Data)
    },
    SetLayout() {
      let $componentEl = $(this.$el)
      if(this.OptionsToggleStatus) {
        const $el = $(this.$refs.StationOptions)
        $componentEl.css({marginBottom: $el.height()})
      } else {
        $componentEl.css({marginBottom: 20})
      }

      this.$emit('reloadStationsLayout')
    },
    /**
     *  \brief   start one station and stop all stations
     *  \param   event, id - station id
     *  \return  void
     */
    StartAndStop(event, data, id) {
      if(this.Type === 'survey') {
        if(this.Data.isRunning) {
          this.StopStEntry(data)
        } else {
          this.SocketMessageSend({component: 'Survey', command: 'Start', 'id': id, 'time': 600})
        }
      } else if(data.StationInProgram) {
        this.StopStEntry(data)
      } else {
        this.$emit('SetPageMessage', {
          target: 'ShowModal',
          modalData: {
            component: 'StationsSetTime',
            data: id,
            row: data
          }
        })
      }
    },
    /**
     *  \brief   Stop a running entry
     *  \param   Array with handleID - Entry's handle ID
     *  \return  void
     */
    StopStEntry(Data) {
      let DataID
      if(Data.SelectedData) {
        DataID = Data.SelectedData.handleID
        this.SocketMessageSend({component: 'Stations', command: 'Stop', 'handleID': [Number(DataID)]})
        this.SocketMessageSend({component: 'Programs', command: 'Mounted'})
        this.Data.expectedFlow = ''
        this.Data.Id = ''
        this.Data.description = ''
        this.Data.name = ''
        this.Data.stStat = 'Passive'
        this.Data.station = '0'
        this.Data.emptyStationState = true
        this.$emit('CloseModal')
      } else if(this.StStat === null) {
        if(Data.handleID !== undefined) {
          DataID = Data.handleID.handleID
          DataID = (DataID === undefined) ? Data.handleID : Data.handleID.handleID
        } else {
          DataID = Data.runningEntries[0].handleID
        }
        this.StStat = 'Passive'
        this.SocketMessageSend({component: 'Survey', command: 'Stop', 'handleID': [Number(DataID)]})
      } else if(this.StStat === 'Passive') {
        DataID = Data.ID
        this.StStat = null
        this.SocketMessageSend({component: 'Survey', command: 'Start', id: [Data.ID], 'time': 600})
      } else {
        DataID = Data.handleID.handleID
        DataID = (DataID === undefined) ? Data.handleID : Data.handleID.handleID
        this.SocketMessageSend({component: 'Stations', command: 'Stop', 'handleID': [Number(DataID)]})
        if(window.location.href.includes('stations')) {
          setTimeout(() => {
            this.SocketMessageSend({component: 'Stations', command: 'Mounted'})
          }, 0)
        } else if (window.location.href.includes('programs')) {
          setTimeout(() => {
            this.SocketMessageSend({component: 'Programs', command: 'Mounted'})
          }, 0)
        }
        this.$emit('SetPageMessage', {
        })
      }
    },
    ClickStationEdit() {
      this.Data.selected = !this.Data.selected
      this.$emit('StationSelectedStatus', this.Data.selected, this.Data)
    },
    OptionsToggleClick(e) {
      this.OptionsToggleStatus = !this.OptionsToggleStatus
      if(this.StInfo.StaionsInfo) {
        $('.station__controls__run-control').prop('disabled', true)
        $('.station__controls__run-control').css('opacity', '0.3')
      }
    },
    FindStationData(ModalData, StationInfo) {
      let staionsInfo = ModalData
      if(staionsInfo && staionsInfo.entry && staionsInfo.entry.runningStations.length && staionsInfo.entry.runningStations[0].id) {
        let id = ''
        if(staionsInfo && staionsInfo.selSt && staionsInfo.selSt.SelectedData && staionsInfo.selSt.SelectedData.id) {
          id = staionsInfo.selSt.SelectedData.id.slice(1)
        } else {
          id = staionsInfo.entry.runningStations[0].id.slice(1)
        }
        StationInfo.forEach((element, index) => {
          if(id === element.StId) {
            staionsInfo['StaionsInfo'] = element
          }
        })
        return staionsInfo
      }
      return staionsInfo
    },
    SetNewStationValues(StationInfo, Data) {
      let data = Data
      if(StationInfo.StaionsInfo) {
        data.name = StationInfo.StaionsInfo.name
        data.StId = StationInfo.StaionsInfo.StId
        data.expectedFlow = StationInfo.StaionsInfo.expectedFlow
        data.description = StationInfo.StaionsInfo.description
        data.runningEntries = StationInfo.data.runningEntries
        if(StationInfo.entry.runningStations.length) {
          if(StationInfo.entry.runningStations.length > 1)
            data.handleID = StationInfo.selSt.SelectedData.handleID
          else
            data.handleID = StationInfo.entry.runningStations[0]
        } else
          data.handleID = ''
        data['StationInProgram'] = true
        this.Data = data
      }
      if(!StationInfo.StaionsInfo && StationInfo.component === 'RegulateProgram') {
        $('.station__controls__run-control').prop('disabled', true)
        $('.station__controls__run-control').css('opacity', '0.3')
        $('.station').css('opacity', '0.8')
        $('.station').css('filter', 'grayscale(0.5)')
      }
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
      this.$emit('CloseModal')
      let triggerStationsRefresh = { component: 'Stations', command: 'Mounted'}
      this.SocketMessageSend( triggerStationsRefresh )
    },
  }
}
</script>

<style lang="scss">
// Station
.station {
  @include clearfix();
  $optionsMinHeight: 10px;

  display: inline-flex;
  align-items: center;
  position: relative;
  margin: 15px;
  float: left;

  &.disabled {
    opacity: 0.7;
    pointer-events: none;
    // border: 1px solid currentColor;
  }

  .stations-containers & {
    margin: 20px 0px;
  }

  &__current-flow {
    margin: 40px 0px 0px 0px;
    text-align: center;
    float: left;
  }

  &__information {
    $size: 110px;
    box-sizing: border-box;
    position: relative;

    width: $size;
    height: $size;

    border-radius: 50%;
    background: $color-brown-gradient;
    color: $color-white;
    z-index: 1;
    box-shadow: 1px 1px 0px 3px $color-white inset; // Inner 'border'
    // border: 5px solid transparent; // Easy way to shrink the whole thing

    &__name {
      font-size: 18px;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 5px 0 10px;
      text-align: center;
      .svg-inline--fa {
        font-size: 24px;
        padding: 10px 0 1px;
      }
    }

    &__alert {
      position: absolute;
      top: -10px;
      left: 0;
      font-size: 25px;
      z-index: $z-ui+1;
      display: none;

      &--1 {
        display: block;
        color: $color-red-error;
      }
    }

    .radial-range {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: 0px 0px 14px $color-grey;
      transform: rotateZ(-90deg) scale(1.2);
      border: 1px solid $color-white;
      border-radius: 50%;
      z-index: 100;
      pointer-events: none;

      &__ring {
        stroke-dasharray: 339.292;
        stroke-dashoffset: 339.292;
        transition: stroke-dashoffset 0.4s;
      }
    }

    > * {
      box-sizing: border-box;
    }

    img {
      margin-top: 0px;
      width: 35%;
      margin-bottom: -5px;
    }

    p {
      margin: 2px 0;
    }

    &__name {
      height: 50%;
      text-align: center;
      border-bottom: 1px solid $color-white;

      > * {
        display: block;
        margin: 0 auto;
      }
    }

    &__left, &__right {
      height: 50%;
      width: 50%;
      font-size: 12px;
      float: left;
      padding: 5px;

      span {
        font-size: 12px;
        font-family: $font-primary-bold;
      }
    }

    &__left {
      text-align: right;
      border-right: 0.5px solid $color-white;
    }
    &__right {
      text-align: left;
      border-left: 0.5px solid $color-white;
    }
  }
  &__body-wrapper {
    $spacing: 40px;
    box-sizing: border-box;
    border: 1px solid $color-grey;
    margin-left: -$spacing;
    padding-left: $spacing;
    display: flex;
    position: relative;
    box-shadow: 0 5px 5px $color-grey;
    margin-bottom: $optionsMinHeight; // centers the **** thing
    background-color: $color-white;
  }

  &__body {
    box-sizing: border-box;
    width: 160px;
    min-height: 70px;
    display: inline-flex;
    flex-direction: column;
    align-items: stretch;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px 10px 10px 20px;
    // white-space: nowrap;
    overflow: hidden;

    font-size: 15px;

    > * {
      margin: 0;
    }

    h3 {
      font-size: 12px;
      width: 100%;
      word-break: break-all;
    }

    > p {
      margin: 0;
      text-transform: uppercase;
      font-size: 10px;
    }
  }
  &__options {
    @include optionsPanel();
  }
  &__select {
    display: inline-flex;
    align-items: center;
    border-left: 1px solid $color-grey;

    > .g-fancy-checkbox {
      padding: 15px;
      margin: 15px;
    }
  }
  &__controls {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid $color-grey;
    position: relative;

    &__edit {
      position: absolute;
      bottom: 100%;
      right: 0;
      left: 0;
      &__button {
        box-sizing: border-box;
        width: 100%;
        margin: 0 !important; // TODO: no !important
        border-color: $color-grey !important; // TODO: no !important
        border-top-right-radius: $application-base-border-radius;
        border-top-left-radius: $application-base-border-radius;
      }
    }

    &__run-control {
      $size: 60px;
      width: $size;
      height: $size;
      padding: 15px;
      margin: 15px;
      font-size: 20px;

      &__play {
        transform: translateX(15%);
      }

      .station__options & {
        margin: 0 8px;
      }
    }
  }
}

</style>
